<div class="intro" class:expand={!expand} class:play={!expand&&isPlay} class:work={!expand&&isWork}>
  {#if !expand}
  <div class="hover">    
    <div class="isWork" on:click={toggleWork} on:mouseover={()=>{isWork=true}} on:mouseout={mout}></div>
    <div class="isPlay" on:click={togglePlay} on:mouseover={()=>{isPlay=true}} on:mouseout={mout}></div>
  </div>
  {/if}

  {#if !expand}<a href="/work" on:click|preventDefault={toggleWork} class="title work">&nbsp;</a>{/if}

  <Work show={expand} />

  {#if !expand}<a href="/play" on:click|preventDefault={togglePlay} class="title play">&nbsp;</a>{/if}

  <Play show={expand} />
</div>

<style type="text/scss">
.intro{
  position:relative;
  text-align:center;
  min-height:90%;
  background-size:contain;
  background-repeat:no-repeat;
  background-position:50% 50%;

  .isWork,.isPlay{ cursor:pointer; }

  .hover{
    position:absolute;
    top:0px; left:0px; width:100%; height:100%;
    .isWork{ top:0px; height:50vh; }
    .isPlay{ top:50vh; height:50vh; }
  }

  &.expand{
    background-image:url('/res/title-playwork.svg');
    margin-bottom:0vh;
  }

  &.play{
    background-image:url('/res/title-playwork-play.svg');
  }
  &.work{
    background-image:url('/res/title-playwork-work.svg');
  }

  a.title{
    background-repeat:no-repeat;
    background-position:50% 50%;
    display:block;
    background-size:contain;
    text-decoration:none;
    height:calc(55vh);   
  }
}
@media (max-aspect-ratio: 16/6) {
  .intro{
    width:110%;
    margin-left:-5%;
  }
}
</style>

<script>
import { onMount , onDestroy } from 'svelte'

import { section } from '../stores/navigation'

import Work from './Work.svelte' 
import Play from './Play.svelte'

let expand = false
let lastS = 'tour'
section.subscribe( s => {
  expand = s == 'expand'
  lastS = s
} )

const toggleExpand = () => {
  expand = !expand
  section.set(expand?'expand':'')
}

const toggleWork = () => {
  if( !expand ) setTimeout( () => { window.scrollTo({ top:window.innerHeight+50, behavior: 'smooth' }) } , 100 )
  toggleExpand()
}

const togglePlay = () => {
  if( !expand ) setTimeout( () => { window.scrollTo({ top:window.innerHeight+1400, behavior: 'smooth' }) } , 100 )
  toggleExpand()
}

let isPlay = false
let isWork = false
const mout = () => {
  isPlay = false
  isWork = false
}
</script>